/**
 * @fileoverview GET handler for the "/deliverability/email/:app_group_id/filters" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { deliverabilityEmailAppGroupIdFilters } from "./constants";
import type { GetDeliverabilityEmailAppGroupIdFiltersResult } from "./types";

export const getDeliverabilityEmailAppGroupIdFilters = reactQueryFetcherAdapter(
  deliverabilityEmailAppGroupIdFilters,
  (signal: AbortSignal, appGroupId: string): Promise<GetDeliverabilityEmailAppGroupIdFiltersResult> => {
    return fetch(
      `/deliverability/email/${appGroupId}/filters`,
      "GET",
      {},
      { signal },
      { propagateFetchRequestError: false }
    );
  }
);
